<template>
    <div>
        <div class="row">
            <div class="form-group col-xs-12">
                <textarea class="form-control" v-model="newNote"></textarea>
            </div>
            <div class="form-group col-xs-12">
                <button class="btn btn-default" @click="add">Add Note</button>
            </div>
        </div>

        <h3>Search Notes</h3>
        <div class="panel panel-default">
            <div class="row panel-body">
                <div class="form-group col-md-3 col-sm-4 col-xs-6">
                    <label>Start Date</label>
                    <DatePicker v-model="startDate" :input-attributes="{ class: 'form-control' }"/>
                </div>
                <div class="form-group col-md-3 col-sm-4 col-xs-6">
                    <label>End Date</label>
                    <DatePicker v-model="endDate" :input-attributes="{ class: 'form-control' }"/>
                </div>
                <div class="col-sm-12">
                    <label>Contributors</label>
                    <div class="panel-body report_options">
                        <div v-for="user in tracker.note_users" v-bind:key="user.id">
                            <input type="checkbox" v-model="noteUsers" :id="user.id" :value="user.id"
                                   :checked="user.checked"/>
                            <label :for="user.id">{{ user.name }}</label>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <button @click="search" class="btn btn-default btn_min_width">
                        Search
                    </button>
                </div>
            </div>
        </div>

        <div v-if="tracker.actual_ship">
            <h3>MER DETAILS</h3>
            <div class="row details_container">
                <div class="col-xs-12" v-if="tracker.tracker_mer_id">
                    <router-link :to="`/tracker_mer/${ tracker.tracker_mer_id }`">
                        MER #: {{ tracker.tracker_mer_id }}
                    </router-link>
                </div>
                <div class="col-xs-12" v-if="tracker.tracker_mer_id">
                    <router-link :to="`/tracker/${ tracker.remake_tracker_new_id }`">
                        Order Remake #: {{ tracker.remake_tracker_new_id }}
                    </router-link>
                </div>
                <div v-else>
                    <div class="form-group col-sm-6 col-xs-12">
                        <label>*Type</label>
                        <select v-model="faultGroup" class="form-control">
                            <option value="0">
                                Start an MER:
                            </option>
                            <option v-for="[id, type] in cache.trackerCache.TRACKER_MER_REMAKE_TYPES" v-bind:key="id"
                                    :value="id">
                                {{ type }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-sm-6 col-xs-12" v-if="faultGroup">
                        <label>*Issue Description</label>
                        <select v-model="issue" class="form-control" @change="createMER">
                            <option v-for="[id, type] in this.cache.trackerCache.TRACKER_MER_CAUSE_TYPES"
                                    v-bind:key="id" :value="id">
                                {{ type }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="margin_bottom" v-show="!remake">
                <h3>Remake</h3>
                <button @click="showRemake=true" class="btn btn-default">Start Remake</button>
            </div>
            <div v-show="showRemake && !remake">
                <form>
                    <table class='table'>
                        <tbody>
                        <tr>
                            <td><input type=radio v-model='remakeOption' value="15"></td>
                            <td><label>Customer</label><br>Copy Order, Flag as Customer remake, and copy full invoice
                            </td>
                        </tr>
                        <tr>
                            <td><input type=radio v-model='remakeOption' value="12"></td>
                            <td><label>Design</label><br>Copy Order, Flag as Commission remake, and set invoice to $0
                            </td>
                        </tr>
                        <tr>
                            <td><input type=radio v-model='remakeOption' value="14"></td>
                            <td><label>Freight</label><br>Copy Order, Flag as Freight remake, and set invoice to $0</td>
                        </tr>
                        <tr>
                            <td><input type=radio v-model='remakeOption' value="11"></td>
                            <td><label>Order Entry</label><br>Copy Order, Flag as Commission remake, and set invoice to
                                $0
                            </td>
                        </tr>
                        <tr>
                            <td><input type=radio v-model='remakeOption' value="13"></td>
                            <td><label>Production</label><br>Copy Order, Flag as Commission remake, and set invoice to
                                $0
                            </td>
                        </tr>
                        <tr>
                            <td><input type=radio v-model='remakeOption' value="16"></td>
                            <td><label>Reorder</label><br>Copy Order, Flag as Reorder, and copy full invoice</td>
                        </tr>
                        <tr>
                            <td><input type=radio v-model='remakeOption' value="31"></td>
                            <td><label>Sales</label><br>Copy Order, Flag as Commission remake, and set invoice to $0
                            </td>
                        </tr>
                        <tr>
                            <td><input type=radio v-model='remakeOption' value="127"></td>
                            <td><label>Miscellaneous</label><br>Copy Order and set invoice to $0</td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="form-group"><label>*New Scheduled Ship Date</label>
                        <DatePicker v-model='scheduledShip' :input-attributes="{class: 'form-control'}"/>
                    </div>
                    <div class="form-group"><label>New PO</label><input v-model='distributorPo' class="form-control">
                    </div>
                    <div class="form-group" v-show="remakeOption==127"><label>Misc Description</label><span class="remakeDescription">(max char 30)</span><input maxlength="30" style="width: 100%" type='text' v-model='miscDescription'>
                    </div>
                    <div class="form-group"><label>Issue Description</label><span class="remakeOption">(max char 50)</span><textarea maxlength="50" v-model='issueDescription' class="form-control"></textarea>
                    </div>
                    <div class="form_grid">
                        <label><input type='checkbox' :true-value='1' :false-value=null
                                      name='params[send_confirmation_email]' v-model='sendConfirmationEmail'> Send
                            confirmation email</label></div>

                    <input @click='remakeOrder' type=button value='Remake Order' class="btn btn-default">
                    <input @click='cancelRemake' type=button value='Cancel' class="btn btn-default">

                    <br/>
                </form>
            </div>
            <div v-show='remake'>
                <p>Order Remade! <span v-show='remake.duplicate_po' class='text-warning'>Warning! Duplicate PO</span>
                </p>
                <p>The order number for the remake is #{{ remake.tracker_id }}</p>
                <p>
                    <router-link :to='`/tracker/${remake.tracker_id}`'>Continue to remake order</router-link>
                </p>
                <p><a class="pointer" @click="cancelRemake">Return to current order</a></p>
            </div>
        </div>

        <div v-show="hasNotes">
            <h3>Options</h3>
            <label>
                <input type='checkbox' v-model="tracker.check_notes" @change="updateCheckNotes" :false-value="0"
                       :true-value="1">
                Show Notice on Scheduler
            </label>
        </div>

        <div v-for="[key, rows] in noteTypes" v-bind:key="key">
            <div v-show="rows.length > 0">
                <Notebook :notes="rows"
                          :hideAdd="true"
                          :header="capitalizeFirstLetter(key)"
                          :onlyEmit="true"
                          @read="updateNotes"
                          @strike="updateNotes"
                />
            </div>
        </div>

        <div v-if="typeof tracker !== 'undefined'">
            <Files :files="tracker.customer_files" :visibilityType="'external'" title="Files" @update="updateNotes"
                   :emitOnly="true"/>
            <Files :files="tracker.internal_files" :visibilityType="'internal'" title="Internal Files"
                   @update="updateNotes" :emitOnly="true"/>
        </div>
    </div>
</template>

<script>
import {store} from "@/store/BusinessObject.store";
import trackerCache from "@/cache/tracker.cache";
import DatePicker from "@/components/utils/DatePicker";
import helpers from "@/store/helpers";
import Notebook from "@/components/businessObjects/utils/Notebook";
import Files from "@/components/businessObjects/utils/Files";
import appStore from "@/store/App.store";

export default {
    name: "TrackerNotebook",
    components: {
        Files,
        Notebook,
        DatePicker
    },
    data() {
        return {
            state: store.state,
            appState: appStore.state,
            tracker: {
                notes: {
                    build: [],
                    field: [],
                    invoice: [],
                    quote: [],
                },
            },
            cache: {
                trackerCache
            },
            newNote: null,
            noteUsers: [],
            startDate: null,
            endDate: null,
            faultGroup: 0,
            issue: 0,
            showRemake: false,
            scheduledShip: '',
            distributorPo: '',
            sendConfirmationEmail: 1,
            remakeOption: 11,
            issueDescription: '',
            miscDescription: '',
            remake: false,
        }
    },
    methods: {
        cancelRemake: function () {
            this.showRemake = false
            this.resetForm();
        },
        resetForm: function () {
            this.remakeOption = 11;
            this.scheduledShip = '';
            this.distributorPo = '';
            this.sendConfirmationEmail = 1;
            this.remake = false;
        },
        remakeOrder: function () {
            let params = {
                'params[remake_option]': this.remakeOption,
                'params[scheduled_ship]': this.scheduledShip,
                'params[distributor_po]': this.distributorPo,
                'params[issue_description]': this.issueDescription,
                'params[misc_description]': this.miscDescription,
                'params[send_confirmation_email]': this.sendConfirmationEmail
            };
            store.api('remake', params).then((data) => {
                if (data.opt === 'get') {
                    this.resetForm();
                    this.remake = data;
                }
            });
        },
        load: function () {
            store.api('to_json_notebook').then(data => this.tracker = data);
        },
        add: function () {
            let params = {
                'params[cdi_note]': this.newNote
            };

            this.newNote = null;
            store.api('save_note', params).then(data => this.tracker = data);
        },
        search: function () {
            let options = {
                'params[datetimes][cdi_datetime_from]': this.startDate,
                'params[datetimes][cdi_datetime_to]': this.endDate,
                'params[user_ids]': this.noteUsers,
            };

            store.api('to_json_notebook', options).then(data => this.tracker = data);
        },
        updateNotes: function (data) {
            this.tracker = data;
        },
        createMER: function () {
            if (this.faultGroup == 0 || this.issue == 0) {
                return;
            }
            store.api('save_tracker_mer', {
                'params[fault_group_id]': this.faultGroup,
                'params[cause_id]': this.issue
            }).then(data => this.tracker = data).then(this.createNote)
        },

        createNote: function () {
            let note = 'MER ' + this.tracker.tracker_mer.tracker_mer_id + ' has been opened by ' + this.appState.user.userName;
            this.state.object.id = this.tracker.tracker_mer.tracker_mer_id;
            store.api('add_note', {'params[cdi_note]': note}, 'object.data', 'tracker_mer');
        },

        updateCheckNotes: function () {
            store.save('check_notes', this.tracker.check_notes);
        },
        capitalizeFirstLetter: function (string) {
            return helpers.capitalizeFirstLetter(string);
        }
    },
    computed: {
        currentView: function () {
            return this.state.currentView;
        },
        hasNotes: function () {
            if (this.notes.field.length) {
                return true;
            } else if (this.notes.quote.length) {
                return true;
            } else if (this.notes.invoice.length) {
                return true;
            } else if (this.notes.build.length) {
                return true;
            }

            return false;
        },
        noteTypes: function () {
            if (typeof this.notes === 'undefined') {
                return {};
            }

            return Object.entries(this.notes);
        },
        notes: function () {
            return this.tracker.notes;
        }
    },
    watch: {
        currentView: function () {
            if (this.currentView == 'notebook') {
                this.load();
            }
        }
    },
}
</script>

<style scoped>
.remakeDescription{
    font-size: x-small; font-weight: bold
}
</style>